( (window, document) => {
  "use strict";
  const $ = window.jQuery;

  let cars_slider = document.querySelectorAll('.vodl-cars-slider.pre-init');

  // Re-fetch all available non-intitialized cars-slider(s).
  const init_cars_slider_newpage = () => {

    cars_slider = document.querySelectorAll('.vodl-cars-slider.pre-init');

    if ( cars_slider.length > 0 ) {
      cars_slider.forEach( slider => {
        init_cars_slider( slider );
      });

      window.removeEventListener( 'newPage', init_cars_slider_newpage, false );
    }

  };

  const init_cars_slider = ( slider ) => {

    const slider_wrapper = slider.querySelector('.vodl-cars-slider__carousel-wrapper-slider');

    const sliderAttr = {
      mode: 'horizontal',
      speed: 500,
      slideWidth: 200,
      minSlides: 2,
      maxSlides: 4,
      slideMargin: 20,
      infiniteLoop: false,
      hideControlOnEnd: true,
    };

    $(slider_wrapper).bxSlider(sliderAttr);

    // const height = slider.querySelector('.bx-wrapper').clientHeight + 'px';
    // slider.querySelector('.bx-viewport').style.height = height;

    // Initialized - remove lazy stuff (there's supposed to be only one slider per page).
    slider.classList.remove('pre-init');

  };

  $(document).ready( () => {

    if ( cars_slider.length > 0 ) {

      cars_slider.forEach( slider => {
        init_cars_slider( slider );
      });

    } else {

      // Initialize event listener for lazy cars slider.
      window.addEventListener('newPage', init_cars_slider_newpage, false);
    }

  });

})(window, document);
